import React from 'react';
import { Grid, Paper, Typography, Card, CardContent, Box } from '@mui/material';
import { WaterDrop, Agriculture, Timer, AttachMoney } from '@mui/icons-material';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const waterUsageData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: 'Water Usage (Liters)',
        data: [4000, 3000, 5000, 6000, 4500, 3500],
        borderColor: '#2196f3',
        tension: 0.4,
      },
    ],
  };

  const statsCards = [
    {
      title: 'Total Water Supply',
      value: '50,000 L',
      icon: <WaterDrop sx={{ fontSize: 40, color: '#2196f3' }} />,
    },
    {
      title: 'Active Fields',
      value: '15',
      icon: <Agriculture sx={{ fontSize: 40, color: '#4caf50' }} />,
    },
    {
      title: 'Average Time',
      value: '2.5 hrs',
      icon: <Timer sx={{ fontSize: 40, color: '#ff9800' }} />,
    },
    {
      title: 'Total Revenue',
      value: '₹25,000',
      icon: <AttachMoney sx={{ fontSize: 40, color: '#f44336' }} />,
    },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom>
        Irrigation Management Dashboard
      </Typography>
      
      <Grid container spacing={3}>
        {statsCards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardContent sx={{ textAlign: 'center' }}>
                {card.icon}
                <Typography variant="h6" component="div">
                  {card.title}
                </Typography>
                <Typography variant="h4">
                  {card.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
        
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Water Usage Analysis
            </Typography>
            <Line data={waterUsageData} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
